import { Controller } from "@hotwired/stimulus"

// A drafted document opens in Jane's app-wide side panel (shared/_note_sidebar)
// beside the chat instead of navigating away, the same way a ClickUp task does
// (clickup_panel_controller): a real link to the full page, so cmd-click and
// middle-click still open it in a tab, and a plain click opens the panel.
//
// It also opens the panel on its own the first time a freshly drafted
// document's card appears - the moment Jane finishes writing - once per
// browser session per document, so reloading the chat never re-opens it.
const SEEN_KEY = "jane-document-panel-seen"

export default class extends Controller {
    static values = { auto: Boolean, url: String, title: String, key: String, icon: { type: String, default: "bi-file-earmark-word" }, label: { type: String, default: "Document" } }

    connect() {
        if (!this.autoValue || !this.urlValue || this._alreadyOpened()) return

        this._remember()
        // A tick later, so the side panel's own controller has connected and is listening.
        setTimeout(() => this._open(this.urlValue, this.titleValue), 0)
    }

    open(event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) return

        const opener = event.currentTarget
        if (!opener?.dataset.panelUrl) return

        event.preventDefault()
        this._open(opener.dataset.panelUrl, opener.dataset.panelTitle)
    }

    _open(url, title) {
        window.dispatchEvent(new CustomEvent("jane:open-panel", {
            detail: { url, title, icon: this.iconValue, label: this.labelValue }
        }))
    }

    _seen() {
        try {
            return JSON.parse(window.sessionStorage.getItem(SEEN_KEY) || "[]")
        } catch (_error) {
            return []
        }
    }

    _alreadyOpened() {
        return this.keyValue && this._seen().includes(this.keyValue)
    }

    _remember() {
        if (!this.keyValue) return

        try {
            window.sessionStorage.setItem(SEEN_KEY, JSON.stringify([...this._seen(), this.keyValue].slice(-50)))
        } catch (_error) {
            /* sessionStorage unavailable - it may open again on reload, which is harmless */
        }
    }
}
